const getQueryValue = (key: string) => {
  const query = window.location.search.slice(1);
  const keys = query.split("&");
  for (let i = 0; i < keys.length; i++) {
    const pair = keys[i]!.split("=");
    if (pair[0] === key) {
      return pair[1];
    }
  }
  return "all";
};

export const getHashValue = (key: string, defaultValue: string) => {
  const query = window.location.hash.slice(1);
  const keys = query.split("&");
  for (let i = 0; i < keys.length; i++) {
    const pair = keys[i]!.split("=");
    if (pair[0] === key) {
      return pair[1];
    }
  }
  return defaultValue;
};

export default getQueryValue;
